export const CloseClipboard = () => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M14.0005 16.9096C13.8105 16.9096 13.6205 16.8396 13.4705 16.6896L9.51047 12.7296C9.22047 12.4396 9.22047 11.9596 9.51047 11.6696C9.80047 11.3796 10.2805 11.3796 10.5705 11.6696L14.5305 15.6296C14.8205 15.9196 14.8205 16.3996 14.5305 16.6896C14.3805 16.8296 14.1905 16.9096 14.0005 16.9096Z"
        fill="#4A5368"
      />
      <path
        d="M10.0004 16.9497C9.81043 16.9497 9.62043 16.8797 9.47043 16.7297C9.18043 16.4397 9.18043 15.9597 9.47043 15.6697L13.4304 11.7097C13.7204 11.4197 14.2004 11.4197 14.4904 11.7097C14.7804 11.9997 14.7804 12.4797 14.4904 12.7697L10.5304 16.7297C10.3804 16.8797 10.1904 16.9497 10.0004 16.9497Z"
        fill="#4A5368"
      />
      <path
        d="M14 6.75H10C9.04 6.75 7.25 6.75 7.25 4C7.25 1.25 9.04 1.25 10 1.25H14C14.96 1.25 16.75 1.25 16.75 4C16.75 4.96 16.75 6.75 14 6.75ZM10 2.75C9.01 2.75 8.75 2.75 8.75 4C8.75 5.25 9.01 5.25 10 5.25H14C15.25 5.25 15.25 4.99 15.25 4C15.25 2.75 14.99 2.75 14 2.75H10Z"
        fill="#4A5368"
      />
      <path
        d="M15 22.7504H9C3.38 22.7504 2.25 20.1704 2.25 16.0004V10.0004C2.25 5.44042 3.9 3.49042 7.96 3.28042C8.38 3.26042 8.73 3.57042 8.75 3.99042C8.77 4.41042 8.45 4.75042 8.04 4.77042C5.2 4.93042 3.75 5.78042 3.75 10.0004V16.0004C3.75 19.7004 4.48 21.2504 9 21.2504H15C19.52 21.2504 20.25 19.7004 20.25 16.0004V10.0004C20.25 5.78042 18.8 4.93042 15.96 4.77042C15.55 4.75042 15.23 4.39042 15.25 3.98042C15.27 3.57042 15.63 3.25042 16.04 3.27042C20.1 3.49042 21.75 5.44042 21.75 9.99042V15.9904C21.75 20.1704 20.62 22.7504 15 22.7504Z"
        fill="#4A5368"
      />
    </svg>
  );
};
